import React from 'react';
import EmpivoEvereeLogo from './EmpivoEvereeLogo';

const Step = ({ n, title, text, active }) => (
  <li className="flex gap-3">
    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${active ? 'bg-blue-700 text-white' : 'border-2 border-gray-300 text-gray-400'}`}>{n}</span>
    <div>
      <p className={`text-sm font-semibold ${active ? 'text-gray-900' : 'text-gray-700'}`}>{title}</p>
      <p className="text-sm text-gray-500">{text}</p>
    </div>
  </li>
);

/** Shown before the form: the company pays the one-time setup fee through Stripe first. */
const PaymentLanding = ({ fee, busy, onPay, cancelled }) => (
  <div className="mx-auto max-w-3xl overflow-hidden rounded-lg bg-white shadow-xl ring-1 ring-black/5">
    <EmpivoEvereeLogo />

    <div className="px-6 py-10 md:px-12">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-700">Payroll</p>
      <h1 className="mt-1 text-2xl font-bold text-gray-900 md:text-3xl">Set up payroll with Empivo</h1>
      <p className="mt-2 text-gray-600">
        Pay the one-time setup fee, complete the onboarding forms, and we’ll send your signed package to Everee for you.
      </p>

      {cancelled && (
        <p className="mt-5 rounded border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Payment was cancelled – no charge was made. You can try again whenever you’re ready.
        </p>
      )}

      <div className="mt-8 grid gap-8 md:grid-cols-[1fr_260px]">
        <ol className="space-y-5">
          <Step n="1" active title="Pay the setup fee" text="Secure card payment through Stripe." />
          <Step n="2" title="Complete the onboarding forms" text="Company, ownership, payroll details, documents and your e-signature." />
          <Step n="3" title="We send it to Everee" text="Your completed form is emailed to Everee automatically when you submit." />
        </ol>

        <div className="rounded-lg border border-[#cfcac2] bg-[#faf9f7] p-5 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">One-time setup fee</p>
          <p className="mt-1 text-4xl font-bold tabular-nums text-gray-900">${Number(fee).toLocaleString()}</p>
          <button
            type="button"
            onClick={onPay}
            disabled={busy}
            className="mt-5 w-full rounded bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50"
          >
            {busy ? 'Redirecting to Stripe…' : `Pay $${Number(fee).toLocaleString()} & continue`}
          </button>
          <p className="mt-3 text-xs text-gray-500">You’ll be redirected to Stripe to pay securely. We never see your card details.</p>
        </div>
      </div>
    </div>
  </div>
);

export default PaymentLanding;
